import { useSubscribeExperimentWebsocketEvents } from "@lib/experiment/useSubscribeExperimentWebsocketEvents";
import { useSubscribeResearchWebsocketEvents } from "@lib/research/useSubscribeResearchWebsocketEvents";

/** App-level websocket subscriptions that keep react-query caches in sync. */
export function useSubscribeWebsocketEvents(): void {
  useSubscribeExperimentWebsocketEvents();
  useSubscribeResearchWebsocketEvents();
}
